import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getDuration = async () => {
  return await get<ApiResponse<any[]>>("/duration").then((res) => res);
};

